import React, { useContext } from 'react';
import styled from 'styled-components/macro';

import { fontkoKR } from '@mirinae/react-ui';

import PlayerContext from '@mirinae/lessons/modules/contexts/player';
import Element from '@mirinae/lessons/components/lesson/elements/Element';
import { lessonsPalette } from '@mirinae/lessons/modules/defines/styles';
// import { lessonsPaths, explorerPaths, membersPaths, authPaths} from '../../../modules/defines/paths';

const PatternTitleWrapper = styled(Element)`
    display: flex;
    flex-direction: column;
    align-items: center;
`;

const Listing = styled.div`
    margin-bottom: 5px;
    color: ${lessonsPalette.grey[4]};
    font-size: 16px;
    font-weight: 700;
    text-transform: uppercase;
    text-align: center;
`;

const Title = styled.div`
    color: ${lessonsPalette.grey[0]};
    font-size: 38px;
    font-weight: 700;
    font-family: ${fontkoKR};
    text-align: center;
`;

const Subtitle = styled.div`
    margin-top: 10px;
    color: ${lessonsPalette.lessons[1]};
    font-size: 16px;
    font-weight: 600;
    text-align: center;
`;

const Notes = styled.div`
    margin-top: 20px;
    max-width: 500px;
    color: #6e6e6e;
    font-size: 14px;
    font-weight: 600;
    text-align: center;
`;

const PatternTitle = ({ element }) => {
    const player = useContext(PlayerContext);
    const lesson = player.currentLesson;

    return (
        <PatternTitleWrapper element={element}>
            { element.type === 'customPatternTitle' ? (
                <>
                    <Listing>{element.fieldsByName.listingLabel.value}</Listing>
                    <Title>{element.fieldsByName.title.value}</Title>
                    <Subtitle>{element.fieldsByName.subtitle.value}</Subtitle>
                </>
            ) : (
                <>
                    <Listing>{lesson.listingLabel}</Listing>
                    <Title>{(element.type === 'startPageTitle' && lesson.startPageTitle) || lesson.title}</Title>
                    <Subtitle>{lesson.subtitle}</Subtitle>
                    { lesson.notes && <Notes>{lesson.notes}</Notes> }
                </>
            )}
        </PatternTitleWrapper>
    );
};

export default PatternTitle;
